import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { MatCardModule } from '@angular/material/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { ColdSinusFluIconSvgComponent } from '../../../../../assets/svg/web/cold-sinus-flu-icon';
import { PinkEyeIconSvgComponent } from '../../../../../assets/svg/web/pink-eye-icon';
import { SkinConditionIconSvgComponent } from '../../../../../assets/svg/web/skin-condition-icon';
import { StomachIssuesIconSvgComponent } from '../../../../../assets/svg/web/stomach-issues-icon';
import { UrinaryTractInfectionIconSvgComponent } from '../../../../../assets/svg/web/urinary-tract-infection-icon';
import { YeastInfectionIconSvgComponent } from '../../../../../assets/svg/web/yeast-infection-icon';
import { EarPainSvgComponent } from "../../../../../assets/svg/web/ear-pain-icon";
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-ask-a-doctor-option-card',
  imports: [
    CommonModule, TranslateModule, MatCardModule, MatButtonModule,
    ColdSinusFluIconSvgComponent,
    PinkEyeIconSvgComponent,
    YeastInfectionIconSvgComponent,
    UrinaryTractInfectionIconSvgComponent,
    StomachIssuesIconSvgComponent,
    SkinConditionIconSvgComponent,
    EarPainSvgComponent
],
  templateUrl: './ask-a-doctor-option-card.component.html',
  styleUrl: './ask-a-doctor-option-card.component.css'
})
export class AskADoctorOptionCardComponent {
  @Input() title!: string;
  @Input() deepLink!: string;
  @Input() photoUrl!: string;
  @Input() symptomID!: string;
  @Input() deepLinkNoAuth!: string;
  @Input() waitTime!: string;
  @Input() locale: string | null = null;

  public soonAsText: string = 'AS_SOON_AS';
  public minutesText: string = 'MINUTES';
  public startNowText: string = 'START_NOW';

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    // Set the default language for translations
     this.translate.use(sessionStorage.getItem("locale") || 'en-US'); // Default to 'en-US' if no locale is provided
  }

   ngOnInit() {
    this.translate.get('AS_SOON_AS').subscribe((translated: string) => {
      this.soonAsText = translated;
    });

    this.translate.get('MINUTES').subscribe((translated: string) => {
      this.minutesText = translated;
    });

    this.translate.get('START_NOW').subscribe((translated: string) => {
      this.startNowText = translated;
    });
  }

  startNow() {
    const eptID = sessionStorage.getItem("eptID");

    if (eptID == null || eptID == undefined || eptID == "") {
      this.startNowUnAuth();
    }
    else {
      this.startNowAuth();
    } 
  }

  startNowUnAuth() {
    var deepLinkURL = environment.web_quickcare_unauth_deep_link_base_url + "/conditions/" + this.symptomID ;

    this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'get-care-now', subfeature: 'QuickCare', platform: 'web' }); // log as web event
  
    console.log("Start now clicked (QuickCare)");
    console.log(deepLinkURL);
  
    window.location.href = deepLinkURL;
  }

  startNowAuth() {
      var deepLinkURL = '';
  
      // For now, we will use the standard QuickCare deep link
      deepLinkURL = environment.web_fdi_deep_link_base_url;


      if (this.photoUrl != null && this.photoUrl != undefined && this.photoUrl != "") {
        if (this.photoUrl.includes('Cold-Sinus-Flu')) {
          deepLinkURL += environment.fdi_option_qc_cough;
        } else if (this.photoUrl.includes('Skin-Condition')) {
          deepLinkURL += environment.fdi_option_qc_skin;
        } else if (this.photoUrl.includes('Pink-Eye')) {
          deepLinkURL += environment.fdi_option_qc_pinkeye;
        } else if (this.photoUrl.includes('Stomach-Issues')) {
          deepLinkURL += environment.fdi_option_qc_stomach;
        } else if (this.photoUrl.includes('Urinary-Tract-Infection')) {
          deepLinkURL += environment.fdi_option_qc_uti;
        } else if (this.photoUrl.includes('Yeast-Infection')) {
          deepLinkURL += environment.fdi_option_qc_yeast;
        } else {
          // if no match, default to standard quickcare deep link
          deepLinkURL = environment.web_quickcare_deep_link_base_url;
        }
      }
      else {
        deepLinkURL = environment.web_quickcare_deep_link_base_url;
      }
      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'QuickCare', platform: 'web' }); // log as web event

      console.log("Start now clicked (QuickCare)");
      console.log(deepLinkURL);
  
      window.location.href = deepLinkURL;
  
    }

}


